import {BaseResponseDTO} from "./base.response.dto";
import {KpiDTO} from "../kpi.dto";


export class GetKPISgestionJornadaResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: Array<KpiDTO>;

}
